import { computed } from 'vue'
import { debounce } from 'lodash'

export function useDebounceComputed<T>(initialValue: T, wait: number) {
  const valueRef = ref(initialValue)

  return computed({
    get() {
      return valueRef.value
    },
    set: debounce((query) => {
      valueRef.value = query
    }, wait)
  })
}
